// FILE: client/src/actions/creditActions.js
import api from "../utils/axiosInstance";
import * as C from "../constants/creditConstants";
import { getApiErrorMessage } from "../utils/errorMessages";

const authHeader = (getState) => {
  const state = typeof getState === "function" ? getState() : {};
  const userInfo = state.userAuth?.userInfo || state.userLogin?.userInfo || {};
  const token = userInfo?.token;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const encodePath = (value = "") =>
  encodeURIComponent(String(value || "").trim());

export const listCredits = () => async (dispatch) => {
  try {
    dispatch({ type: C.CREDIT_LIST_REQUEST });
    const { data } = await api.get("/credits");
    dispatch({ type: C.CREDIT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: C.CREDIT_LIST_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not load credits right now. Please try again later.",
      }),
    });
  }
};
export const listCreditsAdmin = () => async (dispatch) => {
  try {
    dispatch({ type: C.CREDIT_ADMIN_LIST_REQUEST });

    const { data } = await api.get("/credits/admin");

    dispatch({
      type: C.CREDIT_ADMIN_LIST_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const payload = getApiErrorMessage(error, {
      fallback:
        "We could not load admin credits right now. Please try again later.",
    });

    dispatch({
      type: C.CREDIT_ADMIN_LIST_FAIL,
      payload,
    });

    throw new Error(payload);
  }
};

export const getCreditDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: C.CREDIT_DETAILS_REQUEST });
    const { data } = await api.get(`/credits/admin/${encodePath(id)}`, {
      headers: authHeader(getState),
    });
    dispatch({ type: C.CREDIT_DETAILS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: C.CREDIT_DETAILS_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not load this credit block right now. Please try again later.",
      }),
    });
  }
};

export const createCreditBlock = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: C.CREDIT_CREATE_REQUEST });
    const { data } = await api.post("/credits/admin", payload, {
      headers: authHeader(getState),
    });
    dispatch({ type: C.CREDIT_CREATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: C.CREDIT_CREATE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not create this credit block right now. Please try again later.",
      }),
    });
  }
};

export const updateCreditBlock = (id, payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: C.CREDIT_UPDATE_REQUEST });
    const { data } = await api.put(`/credits/admin/${encodePath(id)}`, payload, {
      headers: authHeader(getState),
    });
    dispatch({ type: C.CREDIT_UPDATE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: C.CREDIT_UPDATE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not update this credit block right now. Please try again later.",
      }),
    });
  }
};

export const deleteCreditBlock = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: C.CREDIT_DELETE_REQUEST });
    const { data } = await api.delete(`/credits/admin/${encodePath(id)}`, {
      headers: authHeader(getState),
    });
    dispatch({ type: C.CREDIT_DELETE_SUCCESS });
    return data;
  } catch (error) {
    dispatch({
      type: C.CREDIT_DELETE_FAIL,
      payload: getApiErrorMessage(error, {
        fallback:
          "We could not delete this credit block right now. Please try again later.",
      }),
    });
  }
};
